import React from 'react'
import '../App.css'
import Bodycasinos from './bodycasinos'
export class Bodyappcasinosbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodycasinos/>
                </div>
            </div>
        );
    }
}